import actionTypes from "./actionTypes"

//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//
//               TRAILER                        //
//-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~-~//

export const setTrailerMovie = (trailerMovie = null) => ({
    type: actionTypes.UI_SET_TRAILER_MOVIE,
    payload: {
        trailerMovie: trailerMovie
    }
})

export const setYoutubeCookieConfirmation = (hasConfirmation = 'init') => ({
    type: actionTypes.UI_SET_YOUTUBE_COOKIE_CONFIRMATION,
    payload: {
        hasConfirmation: hasConfirmation
    }
})